import { Injectable, signal } from '@angular/core';

export type ToastType = 'success' | 'error';

export interface ToastItem {
  [x: string]: any;
  id: number;
  message: string;
  type: ToastType;
  title?: string;
  details?: string[];
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private nextId = 1;
  private readonly errorToastDurationMs = 5000;
  private readonly successToastDurationMs = 2000;
  protected readonly itemsSignal = signal<ToastItem[]>([]);

  readonly items = this.itemsSignal.asReadonly();

  show(message: string, type: ToastType, durationMs?: number, title = '', details: string[] = []): void {
    const normalizedMessage = message.trim();
    const normalizedTitle = title.trim();
    if (!normalizedMessage && !normalizedTitle) {
      return;
    }

    const toast: ToastItem = {
      id: this.nextId++,
      message: normalizedMessage,
      type,
      title: normalizedTitle || undefined,
      details: details.length ? details : undefined,
    };

    this.itemsSignal.set([toast]);

    const effectiveDurationMs = durationMs ?? this.getDefaultDuration(type);
    if (effectiveDurationMs > 0) {
      setTimeout(() => this.dismiss(toast.id), effectiveDurationMs);
    }
  }

  private getDefaultDuration(type: ToastType): number {
    return type === 'error' ? this.errorToastDurationMs : this.successToastDurationMs;
  }

  dismiss(id: number): void {
    this.itemsSignal.update((items) => items.filter((item) => item.id !== id));
  }

  clear(): void {
    this.itemsSignal.set([]);
  }
}
